export const DEV_ORIGIN = "http://localhost:3000";
export const BASE_ORIGIN = "https://pos.thevelvet.in";
export const DOMAIN = "thevelvet.in";
export const USERNAME_EXTENTION = `@${DOMAIN}`;
export const API_BASE_V1 = `${BASE_ORIGIN}/api/v1`;
export const API_AUTH = `${API_BASE_V1}/auth`;
